import React from 'react'
import { Stack } from '@mui/material'
import Paragraph from '../Paragraph'

export interface ActionedInfoProps {
  actionedBy: string
  formattedActionDate: string | undefined
}

function ActionedInfo({ actionedBy, formattedActionDate }: ActionedInfoProps) {
  return (
    <>
      <Stack direction="row" justifyContent="space-between">
        <Paragraph weight="bold">Actioned Date</Paragraph>
        <Paragraph>{formattedActionDate}</Paragraph>
      </Stack>
      <Stack direction="row" justifyContent="space-between" marginBottom={4}>
        <Paragraph weight="bold">Actioned By</Paragraph>
        <Paragraph>{actionedBy}</Paragraph>
      </Stack>
    </>
  )
}

export default ActionedInfo 